import { Menu, type MenuProps } from 'antd'
import { useLocation } from 'react-router-dom'
import { useSafeNavigate } from '@/shared/lib/safe-navigate'
import { ArrowRightIcon } from '@/shared/ui/icons'
import './sidebar-menu.css'

export interface SidebarMenuProps {
  items: MenuProps['items'] | any[]
  collapsed?: boolean
  mode?: 'vertical' | 'horizontal' | 'inline'
  activePath?: string
  setActivePath?: (path: string) => void
  handleToggle?: () => void
}

export function SidebarMenu({
  items = [],
  collapsed,
  mode,
  setActivePath,
}: SidebarMenuProps) {
  const navigate = useSafeNavigate()
  const { pathname } = useLocation()

  const handleClick = (item: { key: string }) => {
    if (item?.key) {
      navigate(item.key)
      setActivePath?.(item.key)
    }
  }

  const flatChildren = (items || []).flatMap(
    (item) => (item as { children?: { key: string }[] })?.children || []
  )
  const activeMenuItem = flatChildren.find((child) =>
    pathname?.includes((child as { key: string }).key)
  )
  const activeKey = activeMenuItem ? [(activeMenuItem as { key: string }).key] : []

  return (
    <div className="glasspro-sidebar-menu flex max-w-[250px] min-w-16 h-[calc(100vh-64px)] bg-(--sidebar-bg)">
      <Menu
        className="glasspro-sidebar-menu-inner"
        style={{ overflowY: 'auto' }}
        items={items}
        onClick={handleClick}
        inlineCollapsed={collapsed}
        expandIcon={<ArrowRightIcon />}
        mode={mode ?? 'inline'}
        selectedKeys={activeKey}
        defaultSelectedKeys={activeKey.length ? activeKey : [pathname]}
      />
    </div>
  )
}
